// extracted by mini-css-extract-plugin
module.exports = {"header":"UserHeader_header__2-STx"};